import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=103c9626&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=103c9626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c9626",
  null
  
)

export default component.exports